<!-- 修改个人资料 -->
<template>
	<el-dialog :title="$t('personalInfo')" :visible.sync="visible" width="800px" top="5vh" center
		class="personal-dialog" :before-close="handleClose" :close-on-click-modal="false">
		<el-form :model="userInfo" :rules="personalRules" ref="personalForm" label-width="140px" class="personal-form"
			label-position="top">
			<el-row>
				<el-col :span="6">
					<el-form-item :label="$t('uploadAvatar')" prop="face">
						<!-- 上传状态遮罩层 -->
						<div v-if="isUploadAvatar" class="upload-mask waiting">
							<div class="upload-mask-content">
								<i class="el-icon-loading el-icon--right"></i>
								<span>{{ $t('uploading') }}</span>
							</div>
						</div>
						<img :src="userInfo.face" style="width: 120px;height: 120px;border-radius: 8px;">
						<div class="upload-button">
							<el-upload :action="uploadUrl" ref="upload" :on-success="handleSuccess" :headers="headers"
								:show-file-list="false" :before-upload="beforeUpload">
								<el-button class="image-search-button">
									<span>{{$t('changeAvatar')}}</span>
								</el-button>
							</el-upload>
						</div>
					</el-form-item>
				</el-col>
				<el-col :span="18">
					<el-row>
						<el-col :span="24">
							<el-form-item :label="$t('nickname')" prop="nickName">
								<el-input v-model="userInfo.nickName" :placeholder="$t('inputNickName')" maxlength="20"
									show-word-limit></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item :label="$t('sex')" prop="sex">
								<el-select v-model="userInfo.sex" :placeholder="$t('selectSex')" class="form-select">
									<el-option :label="$t('male')" :value="1"></el-option>
									<el-option :label="$t('female')" :value="0"></el-option>
									<el-option :label="$t('other')" :value="-1"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item :label="$t('country')" prop="countryCode">
								<el-select v-model="userInfo.countryCode" :placeholder="$t('selectCountry')"
									class="form-select" filterable>
									<el-option v-for="item in countries" :key="item.countryCode"
										:label="`${item.countryName}`" :value="item.countryCode">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<div style="padding-bottom: 10px;">{{$t('email2')}}：{{userInfo.email}}</div>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-form-item :label="$t('personalDesc')" prop="remark">
						<el-input type="textarea" v-model="userInfo.remark" :rows="4"
							:placeholder="$t('inputPersonalDesc')" maxlength="200" show-word-limit></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="handleClose">{{ $t('cancel') }}</el-button>
			<el-button type="primary" @click="submitPersonal" :loading="isSubmit">{{ $t('confirm') }}</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import API_DOMAINS from '@/api/core/config'
	import storage from "@/utils/storage.js";
	import userApi from '@/api/user'
	export default {
		name: 'personalDialog',
		props: {
			visible: {
				type: Boolean,
				default: false
			},
			storeId: {
				type: String,
				default: null
			}
		},
		data() {
			return {
				localVisible: this.visible,
				uploadUrl: API_DOMAINS.uploadUrl,
				headers: {
					"accessToken": storage.getToken()
				},
				isSubmit: false,
				countries: [],
				userInfo: {},
				uploadUrl: API_DOMAINS.uploadUrl,
				headers: {
					"accessToken": storage.getToken()
				},
				isUploadAvatar: false //是否上传头像
			}
		},
		watch: {
			visible(val) {
				this.localVisible = val;
				if (val) {
					this.$nextTick(() => {
						this.$refs.personalForm && this.$refs.personalForm.resetFields();
						this.getCountryCode();
						this.getUserInfo();
					})
				}
			},
			localVisible(val) {
				this.$emit('update:visible', val);
			}
		},
		computed: {
			personalRules() {
				return {
					face: [{
						required: true,
						message: this.$t('inputNickName'),
						trigger: 'change'
					}],
					nickName: [{
						required: true,
						message: this.$t('inputNickName'),
						trigger: 'change'
					}],
					sex: [{
						required: true,
						message: this.$t('selectSex'),
						trigger: 'blur'
					}],
					countryCode: [{
						required: true,
						message: this.$t('selectCountry'),
						trigger: 'blur'
					}]
				}
			}
		},
		methods: {
			//获取国家列表数据
			async getCountryCode() {
				const res = await userApi.getCountryCode();
				this.countries = res.result.countryCodeItems;
			},
			//获取登录用户信息
			getUserInfo() {
				var userInfo = JSON.parse(storage.getUserInfo());
				this.userInfo = userInfo;
			},
			handleClose() {
				this.localVisible = false;
			},
			async submitPersonal() {
				this.$refs.personalForm.validate(async (valid) => {
					if (valid) {
						this.isSubmit = true;
						const res = await userApi.editUser(this.userInfo);
						if (res.code == 200) {
							this.$message.success(this.$t('updatePersonalSuccess'));
							const res = await userApi.getUserInfo();
							if (res.success) {
								storage.setUserInfo(JSON.stringify(res.result));
							}
							this.localVisible = false;
							this.$emit('save-callback', true)
						} else {
							this.$message.success(this.$t('updatePersonalFail'));
						}
						this.isSubmit = false;
					}
				})
			},
			beforeUpload() {
				this.isUploadAvatar = true;
			},
			// 上传成功回调
			handleSuccess(response, file, fileList) {
				this.userInfo.face = response.result;
				setTimeout(() => {
					this.isUploadAvatar = false;
				}, 200)
			},
		}
	}
</script>

<style scoped>
	/* 上传状态遮罩层 */
	.upload-mask {
		position: absolute;
		top: 0;
		left: 0;
		width: 120px;
		height: 120px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: rgba(0, 0, 0, 0.7);
		z-index: 5;
		border-radius: 8px;
		color: #fff;
	}

	.upload-mask.waiting {
		background-color: rgba(0, 0, 0, 0.35);
	}

	.personal-tip {
		color: #666;
		font-size: 12px;
	}

	.personal-alert {
		color: #D9001B;
		font-size: 12px;
	}

	.personal-dialog {
		border-radius: 8px;
	}

	.personal-dialog .el-dialog {
		border-radius: 8px;
	}

	.personal-dialog .el-dialog__header {
		border-bottom: 1px solid #eee;
		padding-bottom: 15px;
	}

	.personal-dialog .el-dialog__title {
		font-weight: 600;
	}

	.personal-form {
		padding: 10px 20px;
		margin-top: -20px;
	}

	.personal-form .el-form-item {
		margin-bottom: 20px;
	}

	.personal-form .el-form-item__label {
		font-weight: 500;
		color: #333;
	}

	.form-select {
		width: 95%;
	}

	.personal-form .el-input__inner {
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		transition: border-color 0.2s;
	}

	.personal-form .el-input__inner:hover {
		border-color: #c0c4cc;
	}

	.personal-form .el-input__inner:focus {
		border-color: #0171F9;
	}

	.personal-form .el-textarea__inner {
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		transition: border-color 0.2s;
	}

	.personal-form .el-textarea__inner:hover {
		border-color: #c0c4cc;
	}

	.personal-form .el-textarea__inner:focus {
		border-color: #0171F9;
	}

	.personal-form .el-select .el-input__inner {
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		transition: border-color 0.2s;
	}

	.personal-form .el-select .el-input__inner:hover {
		border-color: #c0c4cc;
	}

	.personal-form .el-select .el-input__inner:focus {
		border-color: #0171F9;
	}

	.dialog-footer {
		display: flex;
		justify-content: right;
		margin-top: -40px;
	}

	.dialog-footer .el-button {
		padding: 10px 30px;
		border-radius: 4px;
	}

	.dialog-footer .el-button--primary {
		background-color: #0171F9;
		border-color: #0171F9;
	}

	.dialog-footer .el-button--primary:hover {
		background-color: #0158d4;
		border-color: #0158d4;
	}

	:deep .el-input__inner {
		color: #000 !important;
		border: 1px solid #DCDFE6 !important;
	}

	:deep .el-form-item__label {
		margin-bottom: -18px;
	}

	.upload-button {
		position: relative;
		margin-top: -10px;
	}

	.file-input {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		opacity: 0;
		cursor: pointer;
		z-index: 1;
	}

	.image-search-button {
		background-color: #fff;
		border: 1px solid #999;
		color: #333;
		cursor: pointer;
		font-size: 14px;
		display: flex;
		align-items: center;
		border-radius: 6px;
		padding: 5px 15px;
		font-weight: normal;
	}

	.image-search-button:hover {
		background-color: #f2f2f2;
	}
</style>